import React from 'react';
import FaqSC from './faq.styled';
import InfoBanner from '../../components/info-banner';
import FaqBanner from '../../components/faq-banner';
import ContentWrap from '../../components/content-wrap';
import FaqContent from '../../components/faq-content/faq-content';

const Faq = () => {
  return (
    <FaqSC>
      <InfoBanner>
        <FaqBanner />
      </InfoBanner>
      <ContentWrap>
        <FaqContent />
      </ContentWrap>
    </FaqSC>
  );
};

export default Faq;
